import React from "react";
import CountdownCard from "@/components/wedding/CountdownCard";
import { useI18n } from "@/lib/i18n";
import { useAuth } from "@/lib/auth";

const INVITATION_IMG =
  "https://customer-assets.emergentagent.com/job_wed-responsive/artifacts/2f292z0r_1.png";

export default function Home() {
  const { t } = useI18n();
  const { guest } = useAuth();
  return (
    <main data-testid="home-page" className="relative">
      <section id="inicio" data-testid="hero-section" className="relative">
        {guest?.name && (
          <div className="text-center pt-4 pb-2" data-testid="home-greeting">
            <p className="font-script-alt text-2xl sm:text-3xl text-[color:var(--ink-wine)]">
              {t.gate.greeting}, {guest.name} ✿
            </p>
          </div>
        )}
        {/* Invitation image — scrollable as page background */}
        <div className="relative max-w-xl mx-auto px-4 pt-2 pb-72">
          <img
            src={INVITATION_IMG}
            alt="Invitación Selena & Mario"
            className="w-full h-auto block rounded-xl shadow-[0_10px_40px_-15px_rgba(122,31,43,0.25)]"
            data-testid="hero-invitation"
          />
        </div>

        {/* Floating countdown — always visible at bottom while on home */}
        <div
          className="fixed bottom-4 inset-x-0 z-40 px-4 pointer-events-none"
          data-testid="floating-countdown-wrap"
        >
          <div className="pointer-events-auto max-w-md mx-auto">
            <CountdownCard t={t} />
          </div>
        </div>
      </section>
    </main>
  );
}
